import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { TAttachment, TAttachments } from './attachments.model';
import { ClearAttachments } from './attachments.actions';

import {
  API_files_images_size_original,
  API_files_video_file,
} from 'src/app/project/data-providers/api-providers/files-api-provider/files-paths';
import { EStore } from 'src/app/project/shared/enums/store.enum';

import { FilesApiProviderService } from '@core/api';
import { ResponseErrorService } from 'src/app/project/modules/errors/response-error.service';
import { catchError } from 'rxjs/operators';
import { createMediaFileName } from './attachments.utils';

@Injectable({
  providedIn: 'root',
})
export class AttachmentsService {
  private attachments$: Observable<TAttachments>;

  private attachments: TAttachments = {
    media: {
      dates: [],
      attachments: {},
    },
    files: {
      attachmentIds: [],
      attachments: {},
    },
  };

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private store: Store<{ attachments: TAttachments }>,
    private filesApiProviderService: FilesApiProviderService,
    private responseErrorService: ResponseErrorService,
  ) {
    this.attachments$ = this.store.pipe(select(EStore.ATTACHMENTS));

    this.attachments$.subscribe((attachments) => {
      this.attachments = attachments;
    });
  }

  findMediaAttachment(attachmentId: string): TAttachment {
    return this.attachments.media.attachments[attachmentId];
  }

  clearAttachments(): void {
    this.store.dispatch(new ClearAttachments());
  }

  getAttachments(): TAttachments {
    return this.attachments;
  }

  //

  createMediaUrl(mediaItem: TAttachment): string {
    switch (mediaItem.type) {
      case 'Image':
      case 'Image360':
        return API_files_images_size_original(mediaItem.attachmentId);
      case 'Video':
        return API_files_video_file(mediaItem.attachmentId);
      default:
        return '';
    }
  }

  createMediaFileName(id: string, fileName: string, mimeType: string): string {
    return createMediaFileName(id, fileName, mimeType);
  }

  fetchVideoUrl(videoId: string): Observable<string> {
    return this.filesApiProviderService
      .fetchVideoUrl(videoId)
      .pipe(
        catchError((error) =>
          this.responseErrorService.handleRequestError(error, 'Failed to fetch video URL'),
        ),
      );
  }
}
